import { HttpConstants } from "../../protocols/http/http-constants";
import { UpdateUserInputPlanning } from "../../../domain/useages/user-input-planning/update-user-input-planning";
import { HttpPostClient } from "../../protocols/http/http-post-client";

export class RemoteUpdateUserInputPlanning implements UpdateUserInputPlanning {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpPostClient
  ) {}

  async update(params: UpdateUserInputPlanning.Params): Promise<any> {
    const httpResponse = await this.httpPostClient.post({
      url: this.url,
      body: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    return httpResponse.data;
  }
}
